import { render, staticRenderFns } from "./aLteAsideContainer.vue?vue&type=template&id=5c8cad4c&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5c8cad4c', component.options)
    } else {
      api.rerender('5c8cad4c', component.options)
    }
    module.hot.accept("./aLteAsideContainer.vue?vue&type=template&id=5c8cad4c&functional=true", function () {
      api.rerender('5c8cad4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aside/aLteAsideContainer.vue"
export default component.exports